import React from "react";
import { cn } from "../lib/utils";

interface CTABandProps {
  title: string;
  description?: string;
  onOpenDemo: () => void;
  className?: string;
}

export function CTABand({ title, description, onOpenDemo, className }: CTABandProps) {
  return (
    <section
      className={cn("py-12 md:py-16 relative overflow-hidden", className)}
      style={{ backgroundColor: "#0F3328", borderTop: "1px solid #1A4035" }}
    >
      <div className="mx-auto max-w-4xl text-center px-4 sm:px-6 lg:px-8 relative z-10">
        <h2 className="text-3xl font-bold tracking-tight sm:text-4xl text-white mb-4">{title}</h2>
        {description && <p className="text-lg text-[#9ABFB5] mb-6">{description}</p>}
        <button
          type="button"
          onClick={onOpenDemo}
          className="rounded-xl bg-[#2EB39A] px-8 py-3 font-bold text-[#0D2B22] transition-colors hover:bg-[#25927E] text-base"
        >
          Book a Demo
        </button>
      </div>
    </section>
  );
}
